// src/services/api.js

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    // List of endpoints that do not require the Authorization header
    const excludedEndpoints = ['/auth/send-otp/', '/auth/verify-otp/', '/auth/set-password/', '/auth/login/'];
    const isExcluded = excludedEndpoints.some((url) => config.url.includes(url));

    if (token && !isExcluded) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can handle error responses here
    return Promise.reject(error);
  }
);

export default api;
